var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { minMediaQueries, hoverMediaQuery, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { scrollX } from '@finect/tabular-utils/scrollX';
import { getFont } from '@finect/tabular-utils/getFont';
export var tableSizes = {
  compact: {
    headHeight: 36,
    cellHeight: 24,
    headFont: -2,
    bodyFont: -1,
    cellXPadding: 1,
    cellYPadding: 1
  },
  small: {
    headHeight: 42,
    cellHeight: 48,
    headFont: -2,
    bodyFont: -1,
    cellXPadding: 3,
    cellYPadding: 4
  },
  medium: {
    headHeight: 68,
    cellHeight: 80,
    headFont: -1,
    bodyFont: 0,
    cellXPadding: 6,
    cellYPadding: 4
  },
  large: {
    headHeight: 68,
    cellHeight: 80,
    headFont: 0,
    bodyFont: 0,
    cellXPadding: 9,
    cellYPadding: 4
  }
};
var scrollableStyles = css(["", " overflow-y:hidden;"], scrollX);
export var TableInner = styled.div.withConfig({
  displayName: "partials__TableInner",
  componentId: "sc-1j9l0c7-0"
})(["", " ", ""], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 -15px;\n  "]))), function (_ref) {
  var _ref$scrollable = _ref.scrollable,
    scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable;
  return scrollable && scrollableStyles;
});
var scopeStyles = function scopeStyles() {
  return css(["&[scope='row']{position:sticky;z-index:1;z-index:3;left:0;max-width:160px;background-color:#fff;min-width:180px;width:180px;", ";", ";&:before{position:absolute;top:-1px;bottom:-1px;right:-8px;width:8px;content:'';background:linear-gradient(to right,rgb(0 0 0 / 0.05),transparent);}}"], minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      min-width: 170px;\n      width: 240px;\n      max-width: 170px;\n    "]))), minMediaQueries.miniDesktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      min-width: 230px;\n      min-width: 320px;\n      width: 320px;\n    "]))));
};
export var Thead = styled.thead.withConfig({
  displayName: "partials__Thead",
  componentId: "sc-1j9l0c7-1"
})(["", ";tr{border-bottom:1px solid ", ";th{height:", ";", ";border-top:1px solid ", ";border-bottom:1px solid ", ";font-weight:600;color:", ";}}"], function (_ref2) {
  var size = _ref2.size;
  return getFont(tableSizes[size].bodyFont);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciaryM;
}, function (_ref4) {
  var size = _ref4.size;
  return "".concat(tableSizes[size].headHeight, "px");
}, function (_ref5) {
  var size = _ref5.size;
  return getFont(tableSizes[size].headFont);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.terciaryM;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.terciaryM;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.terciaryD;
});
var hoverTrStyles = css(["", ";"], hoverMediaQuery(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    &:hover {\n      td, th {\n        &:after {\n          position: absolute;\n          z-index: 1;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          opacity: 0;\n          opacity: 1;\n          border-bottom: 2px solid ", ";\n          content: '';\n        }\n      }\n    }\n  "])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary;
}));
export var Tbody = styled.tbody.withConfig({
  displayName: "partials__Tbody",
  componentId: "sc-1j9l0c7-2"
})(["", ";tr{&,td,th{background-color:#fff;}td,th{height:", ";}td{position:relative;}", " ", "}"], function (_ref10) {
  var size = _ref10.size;
  return getFont(tableSizes[size].bodyFont);
}, function (_ref11) {
  var size = _ref11.size;
  return "".concat(tableSizes[size].cellHeight, "px");
}, function (_ref12) {
  var fetching = _ref12.fetching;
  return !fetching ? hoverTrStyles : '';
}, function (_ref13) {
  var _ref13$zebra = _ref13.zebra,
    zebra = _ref13$zebra === void 0 ? true : _ref13$zebra;
  return zebra ? "\n      &:nth-child(odd) {\n        &,\n        td,\n        th {\n          background-color: #f0f6ff;\n        }\n      }\n    " : css(["td,th{&:after{position:absolute;z-index:1;bottom:0;left:0;right:0;opacity:0;opacity:1;border-bottom:1px solid ", ";content:'';}}"], function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.uiL;
  });
});
export var Table = styled.table.withConfig({
  displayName: "partials__Table",
  componentId: "sc-1j9l0c7-3"
})(["width:100%;font-size:12px;border-collapse:collapse;border-spacing:0;th:first-child{padding-left:6px;}", " th,td{padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";:nth-child(2){padding-left:", ";}}"], maxMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  th:first-child {\n  padding-left: 15px;\n  }\n  "]))), function (_ref15) {
  var size = _ref15.size;
  return "".concat(tableSizes[size].cellYPadding, "px");
}, function (_ref16) {
  var size = _ref16.size;
  return "".concat(tableSizes[size].cellYPadding, "px");
}, function (_ref17) {
  var size = _ref17.size;
  return "".concat(tableSizes[size].cellXPadding, "px");
}, function (_ref18) {
  var size = _ref18.size;
  return "".concat(tableSizes[size].cellXPadding, "px");
}, function () {
  return "".concat(Number(tableSizes.large.cellXPadding), "px");
});
var noActiveStyles = css(["opacity:0.2;filter:grayscale(75%);"]);
export var Tr = styled.tr.withConfig({
  displayName: "partials__Tr",
  componentId: "sc-1j9l0c7-4"
})(["", ""], function (_ref19) {
  var isActive = _ref19.isActive,
    filterActive = _ref19.filterActive;
  return filterActive && !isActive && noActiveStyles;
});
export var Th = styled.th.withConfig({
  displayName: "partials__Th",
  componentId: "sc-1j9l0c7-5"
})(["white-space:nowrap;", " ", ";", ";", ""], function (_ref20) {
  var textAlign = _ref20.textAlign;
  return textAlign ? "text-align: ".concat(textAlign, ";") : '';
}, function (_ref21) {
  var bold = _ref21.bold;
  return bold ? 'font-weight: 700;' : '';
}, function () {
  return scopeStyles();
}, function (_ref22) {
  var minWidth = _ref22.minWidth;
  return minWidth ? "min-width: ".concat(minWidth, ";") : '';
});
export var Td = styled.td.withConfig({
  displayName: "partials__Td",
  componentId: "sc-1j9l0c7-6"
})(["max-width:200px;background-color:transparent;font-weight:400;white-space:normal;color:", ";text-align:", ";", ";", ";", ";", ""], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.terciary;
}, function (_ref24) {
  var textAlign = _ref24.textAlign;
  return textAlign || 'left';
}, function () {
  return scopeStyles();
}, function (_ref25) {
  var bold = _ref25.bold;
  return bold ? 'font-weight: 700;' : '';
}, function (_ref26) {
  var wrapValue = _ref26.wrapValue;
  return wrapValue && wrapValue === 'nowrap' ? 'white-space: nowrap;' : '';
}, function (_ref27) {
  var textAlign = _ref27.textAlign;
  return textAlign ? "text-align: ".concat(textAlign, ";") : '';
});
export var LabelContent = styled.div.withConfig({
  displayName: "partials__LabelContent",
  componentId: "sc-1j9l0c7-7"
})(["display:flex;align-items:center;justify-content:", ";height:100%;cursor:pointer;user-select:none;"], function (_ref28) {
  var textAlign = _ref28.textAlign;
  return textAlign === 'right' ? 'flex-end' : textAlign === 'left' ? 'flex-start' : 'center';
});
export var ArrowsWrapper = styled.div.withConfig({
  displayName: "partials__ArrowsWrapper",
  componentId: "sc-1j9l0c7-8"
})(["display:flex;align-items:center;align-self:center;flex-flow:column;flex-shrink:0;margin-left:4px;"]);
export var ArrowContent = styled.div.withConfig({
  displayName: "partials__ArrowContent",
  componentId: "sc-1j9l0c7-9"
})(["display:flex;color:", ";"], function (_ref29) {
  var theme = _ref29.theme,
    active = _ref29.active;
  return active ? theme.colors.uiDDD : theme.colors.uiD;
});
export var TableHeader = styled.div.withConfig({
  displayName: "partials__TableHeader",
  componentId: "sc-1j9l0c7-10"
})(["display:flex;justify-content:space-between;"]);
export var TableHeaderActionsBlock = styled.div.withConfig({
  displayName: "partials__TableHeaderActionsBlock",
  componentId: "sc-1j9l0c7-11"
})(["display:flex;flex-flow:column;justify-content:end;padding:12px 0;button:not(:last-child){margin-right:9px;}", " ", ""], maxMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    button:not(:last-child) {\n      display:none;\n    }\n  "]))), maxMediaQueries.phablet(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    p {\n      display:none;\n    }\n  "]))));
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-1j9l0c7-12"
})(["display:inline-flex;margin-right:6px;", ""], maxMediaQueries.phablet(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-right: 0;\n  "]))));